__turbopack_context__.v({
  "activeTab": "style-module-scss-module__I--ZWa__activeTab",
  "bottomContent": "style-module-scss-module__I--ZWa__bottomContent",
  "bottomTitle": "style-module-scss-module__I--ZWa__bottomTitle",
  "caseLink": "style-module-scss-module__I--ZWa__caseLink",
  "caseLinkText": "style-module-scss-module__I--ZWa__caseLinkText",
  "description": "style-module-scss-module__I--ZWa__description",
  "image": "style-module-scss-module__I--ZWa__image",
  "index": "style-module-scss-module__I--ZWa__index",
  "left": "style-module-scss-module__I--ZWa__left",
  "leftWithIndex": "style-module-scss-module__I--ZWa__leftWithIndex",
  "mediaBgCover": "style-module-scss-module__I--ZWa__mediaBgCover",
  "mediaLayer": "style-module-scss-module__I--ZWa__mediaLayer",
  "mobileCard": "style-module-scss-module__I--ZWa__mobileCard",
  "mobileContent": "style-module-scss-module__I--ZWa__mobileContent",
  "mobileList": "style-module-scss-module__I--ZWa__mobileList",
  "mobileMedia": "style-module-scss-module__I--ZWa__mobileMedia",
  "mobileSection": "style-module-scss-module__I--ZWa__mobileSection",
  "pin": "style-module-scss-module__I--ZWa__pin",
  "right": "style-module-scss-module__I--ZWa__right",
  "rightBlock": "style-module-scss-module__I--ZWa__rightBlock",
  "rightStack": "style-module-scss-module__I--ZWa__rightStack",
  "rightTitle": "style-module-scss-module__I--ZWa__rightTitle",
  "rightTitleOnly": "style-module-scss-module__I--ZWa__rightTitleOnly",
  "section": "style-module-scss-module__I--ZWa__section",
  "sectionWithLeftSideText": "style-module-scss-module__I--ZWa__sectionWithLeftSideText",
  "tab": "style-module-scss-module__I--ZWa__tab",
  "tabDescriptionMobile": "style-module-scss-module__I--ZWa__tabDescriptionMobile",
  "tabDescriptionWrap": "style-module-scss-module__I--ZWa__tabDescriptionWrap",
  "tabLabel": "style-module-scss-module__I--ZWa__tabLabel",
  "tabTitleMobile": "style-module-scss-module__I--ZWa__tabTitleMobile",
  "tabs": "style-module-scss-module__I--ZWa__tabs",
  "title": "style-module-scss-module__I--ZWa__title",
  "topContent": "style-module-scss-module__I--ZWa__topContent",
  "video": "style-module-scss-module__I--ZWa__video",
});
